import React from 'react'
import { corporateSiteUrl } from '@environments/environment'

export default function Footer () {
  return (
    <footer>
      <div className="footer-menu">
        <ul>
          <li><a href={`${corporateSiteUrl}/privacy/`}>プライバシーポリシー</a></li>
          <li><a href={`${corporateSiteUrl}/eula/`}>利用規約</a></li>
          <li><a href={`${corporateSiteUrl}/faq/`}>よくあるお問い合わせ</a></li>
        </ul>
      </div>
      <div className="copyright text-center">
        ©️ 2021 GMTS
      </div>
    </footer>
  )
}
